export const trackEvent = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, params);
};

export const trackPageView = (path) =>
  trackEvent("page_view", { page_path: path, page_location: window.location.href });

const LINK_EVENT_RULES = [
  { match: (h) => h.includes("wa.me") || h.includes("whatsform.com"), event: "whatsapp_click" },
  { match: (h) => h.startsWith("tel:"), event: "phone_click" },
  { match: (h) => h.startsWith("mailto:"), event: "email_click" },
  { match: (h) => h.includes("google.com/maps") || h.includes("maps.app.goo.gl"), event: "maps_click" },
];

const classifyLink = (href) => {
  const rule = LINK_EVENT_RULES.find((r) => r.match(href));
  return rule ? rule.event : null;
};

const onDocumentClick = (e) => {
  if (!e.target.closest) return;
  const anchor = e.target.closest("a[href]");
  if (!anchor) return;
  const href = anchor.getAttribute("href") || "";
  const eventName = classifyLink(href);
  if (eventName) trackEvent(eventName, { link_url: href });
};

const loadGtag = (id) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false });
};

export const initAnalytics = () => {
  const id = process.env.REACT_APP_GA_ID;
  if (!id || window.gtag) return;
  loadGtag(id);
  document.addEventListener("click", onDocumentClick);
};
